<section class="sg-cononSubmitainer sg-add-section-dialog" >
    <div class="row m-0 border-bottom p-3">
      <h1 mat-dialog-title class="mb-0 pl-2" *ngIf="!data?.isEdit">Add Section</h1>
      <h1 mat-dialog-title class="mb-0 pl-2" *ngIf="data.isEdit">Edit Section</h1> 
    </div>
    <main mat-dialog-content class="sg-dialog-content py-3 pl-4">
      <form [formGroup]="sectionUserForm">
        <div class="row pt-3">
          <div class="col-3 pt-2 pr-0">
            <label class="sg-form-field-label"> Section Name</label>
            <span class="sg-form-field-required-marker ml-1"
                        matTooltip="Date where this item will start showing in the Home Page"
                        matTooltipClass="sg-tooltip-userdialog">*</span>
          </div>
          <div class="col-9 pl-4">
            <mat-form-field appearance="outline" class="w-50 sg-validation cws-error-container">
              <input matInput type="text" formControlName="sectionName">
            </mat-form-field>
            <!-- <div *ngIf="submitted && this.sectionUserForm.controls.sectionName.errors" class="cws-error-msg">
              <small class="text-danger" *ngIf="this.sectionUserForm.controls.sectionName.errors.required">
                This Field is required</small>
            </div>  -->
          </div>
        </div>
        <div class="row">
          <div class="col-3 pt-2 pr-0">
            <label class="sg-form-field-label">Section Contents</label>
            <span class="sg-form-field-required-marker ml-1">*</span>
          </div>
          <div class="col-9 pl-4">
            <mat-form-field appearance="outline" class="w-100 sg-validation cws-error-container">
              <textarea matInput type="text" rows="10" cols="50" formControlName="sectionDescription"></textarea>
            </mat-form-field>
            <!-- <mat-error></mat-error>
            <div *ngIf="this.sectionUserForm.controls.sectionContent.errors" class="cws-error-msg">
                <small class="text-danger" *ngIf="this.sectionUserForm.controls.sectionContent.errors.required">
                  This Field is required</small>
            </div>  -->
          </div>
        </div>
        <div class="mb-0 mx-0 mt-1">Link List</div>
        <div class="row col-12 px-0 mx-0" formGroupName="linkListGroup">
          <div class="col-4 pl-0 pt-2 pr-2">
            <div class="row mx-0">
              <label class="sg-form-field-label pl-0">Link Name</label>
              <span class="sg-infoIcon pl-0">
                <span class="material-icons-outlined"
                        matTooltip="This name will be the visible link name in the Home Page"
                        matTooltipClass="sg-tooltip-userdialog">help_outline
                </span>
              </span>
            </div>
              <div class="row mx-0 pt-1 mb-0 pb-0">
                <mat-form-field appearance="outline" class="w-100">
                <input matInput  type="text" formControlName="linkName">
                </mat-form-field>
             </div>
              
          </div>
          <div class="col-3 pt-2">
            <div class="row mx-0">
              <label class="sg-form-field-label pl-2">Link Type</label>
            </div>           
              <div class="row mx-0 pt-1 px-0"> 
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select formControlName="linkType"  [(ngModel)]="linkTypeSelected"
                  (selectionChange)="onOptionChange($event)">
                    <mat-option *ngFor="let option of  linkTypeOptions" [value]="option">
                      {{option}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
            </div> 
          </div>
          <div class="col-4 pt-2" *ngIf="linkTypeSelected == 'URL'">
            <div class="row">
              <label class="sg-form-field-label">URL</label>
              <span class="sg-infoIcon">
                <span class="material-icons-outlined"
                        matTooltip="This name will be the visible link name in the Home Page"
                        matTooltipClass="sg-tooltip-userdialog">help_outline
              </span>
              </span>
            </div>
            <div class="row pt-1 pr-2">
              <mat-form-field appearance="outline" class="w-100">
              <input matInput  type="text" formControlName="url">
              </mat-form-field>
           </div>
          </div>
          <div class="col-4 pr-0 pl-2" *ngIf="linkTypeSelected == 'Document'">
            <div class="row mt-5">
              <!-- <u class="sg-read-more"> -->
                <!-- <a  target="_blank">Browse</a> -->
                <input type="file" id="myfile" name="Browse" class="sg-read-more" (change)="onFileSelected($event)" formControlName="fileUpload">
              <!-- </u> -->
              <mat-error *ngIf="isExtensionNotValid">
                The file extension is not allowed.
              </mat-error>
          </div>
          </div>
          <div class="col-1 pl-2 mt-5 d-flex justify-content-center">
            <mat-icon class="gc-edit pointer-cursor mat-primary"
            [ngClass]="payloadArray.enabled !== true ? 'disable-icon' : 'enable-icon'" 
            style="cursor: pointer;" 
            (click)="onUploadFile()">add_circle</mat-icon>
          </div>
        </div>
        <div class="row mx-0">
          <div class="col-12" *ngFor="let item of  linkList; let i = index">
            <u class="sg-read-more ">
                 <a target="_blank" href="item.linkAddress">{{item.linkTitle}}</a>
             </u>
             <span class="material-icons-outlined pointer-cursor mat-primary pl-2" (click)="removeLinkList(i)">close</span> 
         </div>
         </div>
         <div class="row mx-0">
          <div class="col-3 pt-2 pl-0">
            <label class="sg-form-field-label"> Order Sequence</label>
          </div>
          <div class="col-9 pl-4">
            <mat-form-field appearance="outline" class="w-50 sg-validation cws-error-container">
              <input matInput type="number" formControlName="orderSequence">
            </mat-form-field>
          </div>
        </div>
         <div class="row ml-0 pl-0">
          <div class="col-4 pl-0" *ngIf="data?.isEdit">
            <mat-checkbox class="my-2" formControlName="isActive">Is Active?</mat-checkbox>
          </div>
        </div>
       </form>
      </main>
    <div class="border-top row mx-0 justify-content-end" mat-dialog-actions>
      <button mat-raised-button class="mat-primary rep-action-button rep-btn-margin mr-4" 
      [disabled]="isEdit ? enableButtonOnCrossClick ? (!sectionUserForm.dirty || sectionUserForm.invalid) :
      (sectionUserForm.invalid && enableButtonOnCrossClick) :
      sectionUserForm.invalid" 
      (click)="onSaveClick()" type="button"
       >Save</button>
      <button mat-stroked-button class="sg-primary-stroked modal-button rep-neutral-button" type="button"
       (click)="onCancelClick()">Cancel</button>
    </div>
  </section>
  <div class="sg-spinner" style="z-index: 99999;" *ngIf="isLoadingData">
    <mat-spinner></mat-spinner>
  </div>
 